import { useEffect } from "react";
import { toast } from "react-toastify";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _ProductionOrderEvent } from "../../../../../core/services/dataBean/EntityCatalog";



interface Props {
    idProductionOrder: any;
    productionOrderDate: any;
}

export const ProductionOrderEvent = ({ idProductionOrder, productionOrderDate }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_ProductionOrderEvent)

    useEffect(() => {
        getLista();
    }, [idProductionOrder, productionOrderDate])

    const getLista = () => {
        instance.getProductionOrderEventCatalog(idProductionOrder, productionOrderDate).then(
            (resp: any) => {
                setLista(resp)
            }
        ).catch(err => { toast.error(err) })

    }

    const head = [
        { title: 'ID', property: 'IDProductionOrderEvent', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Realizado por', property: 'EmployeeName', visible: true },
        { title: 'Observaciones', property: 'Observations', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
    ]

    return (
        <BasicTable body={lista} head={head} rowSet={setBean} />
    )
}